import styled from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  border-radius: ${radius.lg};
  font-family: ${font.text};
  color: ${colors.ink};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};
`;

export const Title = styled.h3`
  font-size: 17px;
  font-weight: 800;
`;

export const Summary = styled.p`
  font-size: 14px;
  line-height: 1.5;

  b {
    font-size: 18px;
    color: ${colors.brandDeep};
  }

  small {
    color: ${colors.muted};
  }
`;

export const Bar = styled.div`
  height: 8px;
  border-radius: ${radius.pill};
  overflow: hidden;
  background: ${colors.brandSoft};
`;

export const Fill = styled.div`
  height: 100%;
  border-radius: ${radius.pill};
  background: ${colors.success};
`;

export const Warn = styled.p`
  padding: 8px 12px;
  border-radius: ${radius.sm};
  font-size: 13px;
  font-weight: 600;
  color: ${colors.amberDeep};
  background: ${colors.amberSoft};
`;

export const Toggle = styled.button`
  align-self: flex-start;
  padding: 0;
  border: none;
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 700;
  color: ${colors.brandDeep};
  background: none;
  cursor: pointer;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 260px;
  overflow-y: auto;
`;

export const Row = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 14px;

  small {
    color: ${colors.muted};
  }
`;

export const Hint = styled.small`
  font-size: 12px;
  color: ${colors.muted};
`;
